<template>
  <div class="top-up-admin">
    <md-field>
      <md-cell-item arrow @click="goUniBank">
        <div slot="left" class="uniBank">
          <img src="@/assets/ToBank.png">
          <div>UnionBank</div>
        </div>
      </md-cell-item>
    </md-field>
  </div>
</template>

<script>
import { Field, CellItem, Switch } from 'mand-mobile'
export default {
  name: 'UniBank',
  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Switch.name]: Switch
  },

  methods: {
    async goUniBank () {
      window.location.href = `${process.env.VUE_APP_UNION_URL}?tradeSourceType=2&bankNo=103001`
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .md-cell-item-body::before {
  border-bottom: 0 !important;
}

.top-up-admin {
  height: 100%;
  padding: 0 40px;
}

.uniBank {
  display: flex;
  align-items: center;

  img {
    width: 60px;
    height: 60px;
  }

  div {
    margin-left: 20px;
  }
}

.md-field {
  margin-top: 80px;
  padding: 0 24px;
  font-weight: 500;
  color: #333;
  height: 156px;
  border-radius: 32px;
  box-shadow: 0 4px 16px 0 rgba(138, 149, 158, 0.2);

  .md-field-content {
    height: 156px;

    .md-cell-item {
      height: 156px;
      line-height: 98px;
    }
  }
}
</style>
